import React from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Plane, ClipboardList, DollarSign, MapPin } from "lucide-react";
import TravelBoardTab from "@/components/admin/travel/TravelBoardTab";
import BookingsTab from "@/components/admin/travel/BookingsTab";
import BudgetTab from "@/components/admin/travel/BudgetTab";
import StaffLocationsTab from "@/components/admin/travel/StaffLocationsTab";

const EventManagementTravel: React.FC = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-foreground flex items-center gap-2">
          <Plane className="h-6 w-6 text-secondary" />
          Travel
        </h1>
        <p className="text-muted-foreground mt-1">
          Manage flights, hotels, rental cars, and travel budgets for event staff.
        </p>
      </div>

      <Tabs defaultValue="board">
        <TabsList className="grid w-full grid-cols-4">
          <TabsTrigger value="board" className="flex items-center gap-1.5 text-xs sm:text-sm">
            <Plane className="h-4 w-4" />
            <span className="hidden sm:inline">Travel Board</span>
            <span className="sm:hidden">Board</span>
          </TabsTrigger>
          <TabsTrigger value="bookings" className="flex items-center gap-1.5 text-xs sm:text-sm">
            <ClipboardList className="h-4 w-4" />
            <span className="hidden sm:inline">Bookings</span>
            <span className="sm:hidden">Book</span>
          </TabsTrigger>
          <TabsTrigger value="budget" className="flex items-center gap-1.5 text-xs sm:text-sm">
            <DollarSign className="h-4 w-4" />
            <span className="hidden sm:inline">Budget</span>
            <span className="sm:hidden">Budget</span>
          </TabsTrigger>
          <TabsTrigger value="locations" className="flex items-center gap-1.5 text-xs sm:text-sm">
            <MapPin className="h-4 w-4" />
            <span className="hidden sm:inline">Staff Locations</span>
            <span className="sm:hidden">Locations</span>
          </TabsTrigger>
        </TabsList>

        <TabsContent value="board" className="mt-6">
          <TravelBoardTab />
        </TabsContent>
        <TabsContent value="bookings" className="mt-6">
          <BookingsTab />
        </TabsContent>
        <TabsContent value="budget" className="mt-6">
          <BudgetTab />
        </TabsContent>
        <TabsContent value="locations" className="mt-6">
          <StaffLocationsTab />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default EventManagementTravel;
